// src/components/Navbar.js
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Navbar.css';


const Navbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    window.localStorage.clear();
    navigate('/');
  };

  // Close mobile menu when clicking a link
  const handleNavClick = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top mb-4">
      <div className="container-fluid">
        <Link to="/main" className="navbar-brand d-flex align-items-center">
          <i className="bi bi-spotify text-success me-2"></i>
          Spotify Player
        </Link>
        
        <button 
          className={`navbar-toggler ${isOpen ? '' : 'collapsed'}`}
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNav"
          aria-controls="navbarNav" 
          aria-expanded={isOpen} 
          aria-label="Toggle navigation"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item" onClick={handleNavClick}>
              <Link 
                to="/main" 
                className={`nav-link ${location.pathname === '/main' ? 'active' : ''}`}
              >
                <i className="bi bi-play-circle me-1"></i>
                Player
              </Link>
            </li>
            <li className="nav-item" onClick={handleNavClick}>
              <Link 
                to="/playlists" 
                className={`nav-link ${location.pathname === '/playlists' ? 'active' : ''}`}
              >
                <i className="bi bi-music-note-list me-1"></i>
                Playlists
              </Link>
            </li>
            <li className="nav-item" onClick={handleNavClick}>
              <Link 
                to="/podcasts" 
                className={`nav-link ${location.pathname === '/podcasts' ? 'active' : ''}`}
              >
                <i className="bi bi-mic me-1"></i>
                Podcasts
              </Link>
            </li>
            <li className="nav-item" onClick={handleNavClick}>
              <Link 
                to="/albums" 
                className={`nav-link ${location.pathname === '/albums' ? 'active' : ''}`}
              >
                <i className="bi bi-disc me-1"></i>
                Albums
              </Link>
            </li>
          </ul>
          
          <div className="d-flex">
            <button 
              onClick={() => {
                handleLogout();
                handleNavClick();
              }}
              className="btn btn-outline-danger w-100"
            >
              <i className="bi bi-box-arrow-right me-1"></i>
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;